<template>
  <div
    class="empty-button empty-button-get"
    @click="buttonClick"
    :class="{
      'empty-button-get-active' : isClick
    }"
  >
    <div class="empty-button-txt position-center" v-text="$t('global.moreGame')" />
  </div>
</template>

<script>
export default {
  data: () => ({ isClick: false }),
  methods: {
    timeout(callback) {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        try {
          callback()
        } catch(error) {}
      }, 100);
    },
    btnClickEffect(callback) {
      this.isClick = true;
      this.$nextTick(() => this.timeout(() => {
        this.isClick = false;
        this.$nextTick(() => this.timeout(() => callback && callback()));
      }));
    },
    //  点击按钮
    buttonClick() {
      !this.disabled && this.btnClickEffect(() => this.$emit('click'));
    }
  }
}
</script>

<style lang="stylus" scoped>
  .empty-button {
    width: 351px;
    height: 44px;
    border-radius: 22px;
    position: relative;
    margin: 0 auto 12px auto;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 22px;
    transition: all .3s;
  }
  .empty-button-txt {
    white-space: nowrap;
  }
  .empty-button-get {
    background: linear-gradient(180deg, #FFF68A 0%, #FFBD10 100%);
    color: #FC2040;
  }
  .empty-button-get-active {
    background: linear-gradient(180deg, #FFBD10 0%, #FFF68A 100%);
  }
</style>